import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import DateForm from "../types/DateForm";

export const CustomerLastAttForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.CustomerLastAtt}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <DateForm
        node={node}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
